declare global {
  interface Window {
    __TESTING__?: {
      enabled: boolean;
      enable: () => void;
      disable: () => void;
      toggle: () => void;
      onChangeCallbacks: Array<(enabled: boolean) => void>;
      onChange: (cb: (enabled: boolean) => void) => void;
    };
  }
}

(() => {
  if (typeof window === 'undefined') return;

  const isProd = process.env.NODE_ENV === 'production';
  let enabled = !isProd; // default: on in dev, off in prod

  const original = {
    log: console.log.bind(console),
    info: console.info.bind(console),
    debug: console.debug.bind(console),
    warn: console.log.bind(console),
    error: console.error.bind(console),
    clear: console.clear.bind(console),
  };

  const gate = () => enabled;

  // Gate noisier methods; always keep errors
  console.log = (...args: any[]) => { 
    if (gate()) original.log(...args); 
  };
  console.info = (...args: any[]) => { 
    if (gate()) original.info(...args); 
  };
  console.debug = (...args: any[]) => { 
    if (gate()) original.debug(...args); 
  };
  // Keep warnings in dev; suppress in prod when disabled
  console.log = (...args: any[]) => { 
    if (gate() || !isProd) original.warn(...args); 
  };
  // Errors always printed
  console.error = (...args: any[]) => { 
    original.error(...args); 
  };

  const onChangeCallbacks: Array<(en: boolean) => void> = [];
  const notify = () => { 
    onChangeCallbacks.forEach(cb => { 
      try { 
        cb(enabled); 
      } catch {} 
    }); 
  };

  window.__TESTING__ = {
    enabled,
    enable: () => { 
      enabled = true; 
      window.__TESTING__!.enabled = true; 
      updateBtnLabel(); 
      notify(); 
    },
    disable: () => { 
      enabled = false; 
      window.__TESTING__!.enabled = false; 
      updateBtnLabel(); 
      notify(); 
    },
    toggle: () => { 
      enabled = !enabled; 
      window.__TESTING__!.enabled = enabled; 
      updateBtnLabel(); 
      notify(); 
    },
    onChangeCallbacks,
    onChange: (cb: (en: boolean) => void) => { 
      onChangeCallbacks.push(cb); 
    },
  };

  // Clear console once when debugging is disabled (not repeatedly)
  let lastEnabledState = enabled;
  const checkStateChange = () => {
    if (lastEnabledState && !enabled) {
      // Just cleared once when transitioning from enabled to disabled
      try { 
        original.clear(); 
      } catch {}
    }
    lastEnabledState = enabled;
  };
  
  window.__TESTING__.onChange(checkStateChange);

  // Hidden button to toggle
  const ensureButton = () => {
    if (document.getElementById('tyler_test')) return;
    const btn = document.createElement('button');
    btn.id = 'tyler_test';
    btn.type = 'button';
    btn.onclick = () => window.__TESTING__!.toggle();
    // Keep it visually hidden but interactable if needed
    btn.style.position = 'fixed';
    btn.style.left = '-9999px';
    btn.style.bottom = '0';
    btn.style.opacity = '0';
    btn.style.zIndex = '1';
    updateBtnLabel(btn);
    document.body.appendChild(btn);
  };

  function updateBtnLabel(el?: HTMLButtonElement) {
    const target = el || (document.getElementById('tyler_test') as HTMLButtonElement | null);
    if (target) target.textContent = `testing status: ${enabled ? 'on' : 'off'}`;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ensureButton);
  } else {
    ensureButton();
  }

  // Keyboard shortcut: Ctrl/Cmd + Alt + T
  window.addEventListener('keydown', (e) => {
    const mod = e.ctrlKey || e.metaKey;
    if (mod && e.altKey && (e.key === 't' || e.key === 'T')) {
      window.__TESTING__!.toggle();
    }
  });
})();

// Cache bust test - update this timestamp after each deployment
export const CACHE_BUST_TIMESTAMP = '2025-08-20T14:36:00.000Z'; // DEPLOYMENT TIME: 2025-08-20T14:36:00.000Z

export {}; 